module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main